import { apiClient } from './api'

import type { MeasurementSystem } from '../lib/measurementSystem'

export interface OptimizationSettings {
  measurement_system?: MeasurementSystem
  vehicle_registration_required?: boolean
  limits?: {
    max_items_per_job?: number
    max_execution_time_ms?: number
    max_cpu_budget?: number
    max_concurrent_jobs_per_tenant?: number
    max_free_spaces?: number
    max_candidates_global?: number
    max_memory_bytes?: number
    algorithm_versions_allowed?: string[]
  }
  thresholds?: {
    stability?: {
      minSupportRatio?: number
      maxCenterOfGravityDeviation?: number
    }
    axleLoadSafetyMarginPercent?: number
    enforceAxleLimits?: boolean
  }
  constraintWeights?: {
    stability?: number
    weight?: number
    adr?: number
    stackability?: number
    rotation?: number
    accessibility?: number
    centerOfGravity?: number
    // dynamicStability remplacÃ© par les 3 mÃ©triques atomiques
    rollover?: number
    yaw?: number
    roll?: number
    penaltyScale?: number
  }
  optimizationWeights?: {
    utilization?: number
    stability?: number
    // dynamicStability: indicateur composite agrÃ©gÃ© (rollover+yaw+roll), NON pondÃ©rÃ©
    rollover?: number
    yaw?: number
    roll?: number
    weightDistribution?: number
    accessibility?: number
    centerOfGravity?: number
    stackability?: number
    rotationPreference?: number
  }
  optimizationPresets?: Record<string, {
    name: string
    description: string
    icon: string
    weights: Record<string, number>
  }>
  defaultPreset?: string
}

export interface SettingsResponse {
  defaults: OptimizationSettings
  tenantConfig: OptimizationSettings
}

export const settingsService = {
  getSettings: async (): Promise<SettingsResponse> => {
    const { data } = await apiClient.get<SettingsResponse>('/optimization/v1/settings')
    return data
  },

  updateSettings: async (settings: OptimizationSettings): Promise<{ message: string; tenantConfig: OptimizationSettings }> => {
    const { data } = await apiClient.put('/optimization/v1/settings', { saas_config: settings })
    return data
  },

  simulateScoreImpact: async (currentWeights: Record<string, number>, newWeights: Record<string, number>) => {
    const { data } = await apiClient.post('/optimization/v1/settings/simulate', {
      currentWeights,
      newWeights
    })
    return data
  }
}
